<div class="modal-background" bdFxLayoutAlign="center start">
    <form class="filter-modal"  (ngSubmit)="setFilter()">


        <div class="header-small" id="header">
            <div class="title">Filtern nach</div>
            <div class="fixed-div">
                <div class="refresh-button" id="refreshButton">
                    <div (click)="resetFilter()" [ngClass]="{'active':hasFilterValues()}" class="refresh-item">
                        <bd-fa-button [name]="'undo'"></bd-fa-button> &nbsp;Reset
                    </div>
                    <div class="vertical-divider">|</div>
                    <div (click)="closeModal()" class="close-button">
                        <bd-fa-button [name]="'times'"></bd-fa-button>
                    </div>
                </div>
            </div>
        </div>


        <div class="description">Geben Sie mindestens einen Parameter zum Filtern ein.</div>
        <div class="filter-items-content" bdFxLayout="row wrap" bdFxLayoutAlign="space-between start">

            <div bdFxFlex="1 1 100%">
                <div class="filter-item" bdFxFlex="1 1 100%">
                    <div bdFxFlex="1 1 40%">Projektname</div>
                    <app-labeled-clearable-input [(ngModel)]="projectListItemFilter.projectName"
                                                 [clearable]="true"
                                                 #projectNameInput
                                                 [label]="''" [name]="'projectName'"
                                                 [placeholder]="'Bitte eingeben'" [type]="'text'"
                                                 bdFxFlex="1 1 60%">
                    </app-labeled-clearable-input>
                </div>
            </div>

            <div bdFxFlex="1 1 100%">
                <div class="filter-item" bdFxFlex="1 1 100%">
                    <div bdFxFlex="1 1 40%">Firma</div>
                    <app-labeled-clearable-input [(ngModel)]="projectListItemFilter.companyName"
                                                 [clearable]="true"
                                                 [label]="''" [name]="'companyName'"
                                                 [placeholder]="'Bitte eingeben'" [type]="'text'"
                                                 bdFxFlex="1 1 60%">
                    </app-labeled-clearable-input>
                </div>
            </div>

            <div bdFxFlex="1 1 100%">
                <div class="filter-item" bdFxFlex="1 1 100%">
                    <div bdFxFlex="1 1 40%">Gültigkeit</div>
                    <div class="inputs-container" bdFxFlex="1 1 60%">
                        <bd-labeled-date-input [(ngModel)]="projectListItemFilter.validityOfQuotationFromDate"
                                               [bdMaxDate]="projectListItemFilter.validityOfQuotationToDate"
                                               name="validityOfQuotationFromDate"
                                               [datePickerMaxDate]="projectListItemFilter.validityOfQuotationToDate"
                                               placeholder="Von">
                        </bd-labeled-date-input>
                        <bd-labeled-date-input [(ngModel)]="projectListItemFilter.validityOfQuotationToDate"
                                               name="validityOfQuotationToDate"
                                               [bdMinDate]="projectListItemFilter.validityOfQuotationFromDate"
                                               [datePickerMinDate]="projectListItemFilter.validityOfQuotationFromDate"
                                               placeholder="Bis">
                        </bd-labeled-date-input>
                    </div>


                </div>
            </div>


        </div>
        <div class="divider"></div>
        <button type="submit" class="btn btn-primary filter">Anwenden</button>
    </form>


</div>
